import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5e3dd15f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "draggable-strength-inner strength-name-text" }

import { ref, onMounted, onBeforeUnmount } from "vue";
import { Draggable } from "gsap/all";
import Debug from "debug";
import { StrengthAndRating } from "../../views/strengths-mapping/strengths-mapping.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'draggable-strength',
  props: {
    strength: {},
    isCurrent: { type: Boolean }
  },
  emits: ["dragClick", "dragStart", "dragMove", "dragEnd"],
  setup(__props: any, { emit: __emit }) {

const debug = Debug("cs.DraggableStrengthComponent");

const props = __props;

const emit = __emit;

// template refs
const draggableStrength = ref<HTMLElement | null>(null);
const draggableNotch = ref<HTMLElement | null>(null);

const draggable = ref<any | null>(null);

const isBeingDragged = ref(false);

function onClick(event: Event) {
  emit("dragClick", draggableStrength.value, props.strength);
}

function onDragStart(event: Event) {
  isBeingDragged.value = true;
  emit("dragStart", draggableStrength.value, props.strength);
  event.preventDefault();
}

function onDrag() {
  emit("dragMove", draggableStrength.value, props.strength);
}

function onDragEnd() {
  emit("dragEnd", draggableStrength.value, props.strength);
  isBeingDragged.value = false;
}

function initializeDragAndDrop(newStrengthItem?: StrengthAndRating, event?: Event) {
  draggableStrength.value?.classList.remove("disabled");
  [draggable.value] = Draggable.create(draggableStrength.value, {
    onDrag,
    onDragStart,
    onDragEnd,
    onClick,
  });
}

onMounted(() => {
  initializeDragAndDrop();
});

onBeforeUnmount(() => {
  if (draggable.value) {
    draggable.value.kill();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["draggable-strength", { current: _ctx.isCurrent, dragging: isBeingDragged.value, rated: _ctx.strength.rating !== null }]),
    "data-test": "draggable-strength",
    ref_key: "draggableStrength",
    ref: draggableStrength
  }, [
    _createElementVNode("div", {
      ref_key: "draggableNotch",
      ref: draggableNotch,
      class: "draggable-strength-notch"
    }, null, 512),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_ctx.strength.draggableName), 1)
    ])
  ], 2))
}
}

})